(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-provider.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-provider.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useCallback = _React.useCallback;
const HighscoreContext = svs.components.marketplaceCompetition.routeResult.highscore.HighscoreContext;
const HighscoreListType = svs.components.marketplaceCompetition.services.constants.highscoreConstants.HighscoreListType;
const typeToDescription = type => {
  switch (type) {
    case HighscoreListType.Individual:
      return 'deltagare';
    case HighscoreListType.Team:
      return 'lag';
    default:
      return '';
  }
};
const HighscoreProvider = _ref => {
  let children = _ref.children;
  const _useState = useState(HighscoreListType.Individual),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    offset = _useState4[0],
    setOffset = _useState4[1];
  const changeType = useCallback(type => {
    setType(type);
    setOffset(0);
  }, []);
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    searchTerm = _useState6[0],
    setSearchTerm = _useState6[1];
  const providerValue = useMemo(() => ({
    typeDescription: typeToDescription(type),
    type,
    changeType,
    count: 20,
    setSearchTerm,
    searchTerm,
    setOffset,
    offset
  }), [type, changeType, searchTerm, offset]);
  return React.createElement(HighscoreContext.Provider, {
    value: providerValue
  }, children);
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreProvider', HighscoreProvider);

 })(window);